import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, viewChild } from "@angular/core";
import { CalendarOptions, EventClickArg } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import { Dropdown, DropdownChangeEvent } from "primeng/dropdown";
import { ApiService } from "../../core/services/api.service";
import { AuthService } from "../../core/endpoints/auth.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastService } from "../../core/services/toast.service";
import { ConfirmationService } from "primeng/api";
import { Extra } from './../../core/endpoints/models/extra';
import { Service } from './../../core/endpoints/models/service';
import { Housing } from "src/app/core/endpoints/models/housing";
import { Reservation } from "src/app/core/endpoints/models/reservation";
import { FullCalendarComponent } from "@fullcalendar/angular";
import * as moment from "moment";
import "moment/locale/es";

moment.locale("es");

@Component({
  selector: 'app-calendar-services',
  templateUrl: './calendar-services.component.html',
  styleUrl: './calendar-services.component.scss'
})
export class CalendarServicesComponent implements OnInit{
  
  @ViewChild('calendar') calendarComponent: FullCalendarComponent; 
  edit : boolean = false;
  dialog : boolean = false;
  users : any;
  selectedDate : any  = '' ;
  selectedEvent : any = null;
  loggedUser : any;
  loading: boolean = false;
  isDialogVisible : boolean = false;
  services: Service[] = [];
  extras: Extra[] = [];
  housings: Housing[] = [];
  reservations: Reservation[] = [];
  total:any = 0;
	servicesData: any = [];
	extrasData: any = [];
  deleteEnable: boolean = false;

  servicesList: any[] = [];
  extrasList: any[] = [];


  form : FormGroup;
  private calendarApi

  calendarOptions: CalendarOptions = {
    initialView: "dayGridMonth",
    plugins: [dayGridPlugin, interactionPlugin],
    selectable: true,
    eventClick: (arg) => this.handleEventClick(arg),
    dateClick: (arg) => this.handleDateClick(arg),
    datesSet: this.handleMonthChange.bind(this),
    events: [],
    locale: "es",
    buttonText: {
      today: "Hoy",
    },
    firstDay: 1,
    dayCellDidMount: (arg) => {
      const date = new Date(arg.date);
      const self = this;
    },
  };

  constructor(
    private apiService : ApiService,
    private toastService : ToastService,
    private authService : AuthenticationService,
    private cd : ChangeDetectorRef,
    private confirmationService : ConfirmationService,
    private formBuilder : FormBuilder,
		private toast: ToastService
  ){
    this.form = this.formBuilder.group({
      type: ["1"],
      service: [""],
      extra: [""],
      user_id: ["" ,Validators.required],
      housing_id: ["" ,Validators.required],
      date : ["",[Validators.required]],
      time : [""]
    });
    this.loggedUser = this.authService.getUser();
  }

  ngOnInit() {
    if (this.loggedUser.role_id != 4){
      this.loadUsers();
    }else{
      this.loadHousings(this.loggedUser.id,true);
    }
    this.loadServicesAll();
    this.loadExtrasAll();
  }
  
  handleEventClick(clickInfo: EventClickArg) {
    this.servicesList = [];
    this.extrasList = [];
    let schedule = clickInfo.event._def.extendedProps;
    this.showDialog(schedule);
    this.selectedDate = moment(schedule.dateStr).format('DD/MM/YYYY');
    this.selectedEvent = schedule;

    
    let todayFormat = moment().format('YYYY-MM-DD');
    let dateSelected = moment(schedule.dateStr);
    let dateToday = moment(todayFormat);

    const diff = dateSelected.diff(dateToday);
    if (diff < 0){
        this.deleteEnable = false;
    } else if (diff > 0) {
      this.deleteEnable = true;
    } else{
      this.deleteEnable = true;
    }

    if (this.loggedUser.role_id != 4){
      this.deleteEnable = true;
    }

  }

  handleMonthChange(monthInfo: DateClickArg) {
    this.getEvents();
  }
  
  handleDateClick(clickInfo: DateClickArg) {
      this.servicesList = [];
      this.extrasList = [];
      this.deleteEnable = true;
      this.selectedDate = moment(clickInfo.dateStr).format('DD/MM/YYYY');
      
      let todayFormat = moment().format('YYYY-MM-DD');
      let dateSelected = moment(clickInfo.dateStr);
      let dateToday = moment(todayFormat);

      const diff = dateSelected.diff(dateToday);
      if (diff < 0){
        
      } else if (diff > 0) {
        this.isDialogVisible = true;
        this.form.patchValue({
          date:clickInfo.dateStr
        });
      } else{
        this.isDialogVisible = true;
        this.form.patchValue({
          date:clickInfo.dateStr
        });
      }
  }

  loadReservations(month,year){
    this.apiService.addEntity('reservationsMonthYear',{
      month: month,
      year: year 
    }).subscribe({
      next: (response) => {
        this.calendarApi = this.calendarComponent.getApi();
        this.calendarApi.removeAllEvents();

        this.reservations =  response.reservations;

        this.calendarOptions.events = response.reservations?.map((item) => ({
          ...item,
          title: item.housing.title + " - " + item.user.name_surname,
          dateStr: item.date,
          start: item.date,
          reservation_id: item.id,
          backgroundColor: "#"+item.user.color,
          textColor: "#FFFFFF",
          borderColor: "#"+item.user.color,
        }));
      }
    });
  }

  loadServices(id, action : boolean = false){
    this.apiService.getEntity('servicesByHousing',id).subscribe({
      next: (response) => {
        this.services = response.services.map(service => ({
          ...service,
          value: service.id,
          label: this.loggedUser.role_id === 2 ? service.name : service.label
        }));

        if(action){
          this.services.forEach(service => {
            if (service.is_default){
              this.servicesList.push(service);
            }
          });
        }
        this.cd.detectChanges();
        setTimeout(() => {
          this.loadPrices();
        }, 500);
      }
    });
  }
  

  loadExtras(id, action : boolean = false){
    this.apiService.getEntity('extrasByHousing',id).subscribe({
      next: (response) => {
        this.extras = response.extras.map(extra => ({
          ...extra,
          value: extra.id,
          label: this.loggedUser.role_id === 2 ? extra.name : extra.label
        }));

        if(action){
          this.extras.forEach(extra => {
            if (extra.is_default){
              this.extrasList.push(extra);
            }
          });
        }
        this.cd.detectChanges();
        setTimeout(() => {
          this.loadPrices();
        }, 500);
      }
    });
  }

	public loadExtrasAll() {
		this.apiService.getEntity("extras").subscribe({
			next: (result) => {
				result.extras.forEach(element => {
					this.extrasData[element.id] = element;
				});
			},
			error: (err) => {
			},
			complete: () => {
			},
		});
	}

	public loadServicesAll() {
		this.apiService.getEntity("services").subscribe({
			next: (result) => {
				result.services.forEach(element => {
					this.servicesData[element.id] = element;
				});
			},
			error: (err) => {
			},
			complete: () => {
			},
		});
	}
	
  
  loadHousings(id,clear:boolean = false){
    this.apiService.getEntity('housingsByUser',id).subscribe({
      next: (response) => {
        this.housings = response.housings.map(housing => ({
          ...housing,
          value: housing.id,
          label: housing.label
        }));
        if (clear){
          this.form.patchValue({
            'housing_id' : null
          });
        }
        this.cd.detectChanges();
      }
    });
  }

  loadPrices(){
    this.total = 0;
    this.servicesList.forEach(service => {
      this.total += Math.ceil(service.price);
    });
    this.extrasList.forEach(extra => {
      this.total += Math.ceil(extra.price);
    });
  }

  loadUsers(){
    this.apiService.getEntity("users", 4).subscribe({
      next: (result) => {
        this.users = result.users.map((user) => ({
          ...user,
          label: user.name_surname_email,
          value: user.id
        }));
      },
      error: (err) => {
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  updateValueAndValidity() {
    for (let controlName in this.form.controls) {
        this.form.controls[controlName].updateValueAndValidity();
    }
  }
  saveReserve() {
		if (this.loggedUser.role_id == 4){
      this.form.patchValue({
        user_id: this.loggedUser.id,
      });
		}
    this.updateValueAndValidity();

    this.loading = true;


		this.form.markAllAsTouched();
		if (this.form.invalid) {
      this.loading = false;
      return this.toastService.show("Aviso","Revise los datos del formulario.","warn");
		}

		if (this.servicesList.length == 0) {
      this.loading = false;
      return this.toastService.show("Aviso","Debe seleccionar almenos un servicio.","warn");
		}

    var services = [];
    this.servicesList.forEach(service => {
      services.push(service.id);
    });
    var extras = [];
    this.extrasList.forEach(extra => {
      extras.push(extra.id);
    });

    this.form.patchValue({
      service: services,
      extra: extras
    });

    const value = this.form.value;

    let serviceSchedule = {
      ...value,
      servicesList: this.servicesList,
      extrasList: this.extrasList,
    };

    if(this.selectedEvent){
      serviceSchedule.id = this.selectedEvent.reservation_id;

      this.apiService.updateEntity('updateReservation',this.selectedEvent.reservation_id,serviceSchedule).subscribe({
        next: (response) => {
          this.toastService.show("","Reserva actualizada correctamente.","success");
        },
        error: (err) => {
          var error = "Ha ocurrido un error intentando actualizar, intente nuevamente.";
          if (err.error.message){
            error = err.error.message;
          }
          this.toastService.show("",error,"error");
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
          this.resetForm();
          this.getEvents();
        }
      });
    }else{
      this.apiService.addEntity('registerReservation', serviceSchedule).subscribe({
        next: () => {
          this.toastService.show("","Reserva creada correctamente.", "success");
        },
        error: (err) => {
          var error = "Ha ocurrido un error intentando crear, intente nuevamente.";
          if (err.error.message){
            error = err.error.message;
          }
          this.toastService.show("",error, "error");
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
          this.resetForm();
          this.getEvents();
        }
      });
    }
  }

  deleteReserve(scheduleId : number){
    this.apiService.deleteEntity('deleteReservation', scheduleId).subscribe({
      next: () => {
        this.toastService.show("","Reserva eliminada correctamente","success");
        this.getEvents();
      },
      error: (err) => {
        this.toastService.show("","Ha ocurrido un error intentando eliminar la reserva.","error");
        this.loading = false;
        console.error(err)
      },
      complete: () => {
        this.loading = false;
        this.resetForm();
      }
    });
  }

  showDeletingForm(scheduleId : number){
    this.confirmationService.confirm({
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      rejectButtonStyleClass: "p-button-danger",
      icon: "pi pi-exclamation-triangle",
      header: "Eliminar reserva",
      message: "¿ Estás seguro de que deseas eliminar esta reserva ? No se podrán recuperar los datos eliminados.",
      accept: () => {
        this.deleteReserve(scheduleId);
      }
    })
  }

  async showDialog(serviceSchedule? :  any){
    this.edit = false;
    if(serviceSchedule){
      this.edit = true;
      this.loadHousings(serviceSchedule.user_id,false);
      this.loadServices(serviceSchedule.housing_id, false);
      setTimeout(() => {
        var time = null;
        if (serviceSchedule.time){
          time = moment(serviceSchedule.dateStr + ' ' + serviceSchedule.time).format('HH:mm');
        }
        this.form.patchValue({
          user_id: serviceSchedule.user_id,
          housing_id: serviceSchedule.housing_id,
          date : serviceSchedule.dateStr,
          time : time,
          type: serviceSchedule.type.toString()
        });
        setTimeout(() => {
          let servicesSelected = serviceSchedule.servicesId;
          let extrasSelected = serviceSchedule.extrasId;
          
          servicesSelected.forEach(serviceId => {
            let serviceIndex = this.services.findIndex((service) => service.id === serviceId);
            if (serviceIndex != -1){
              this.servicesList.push(this.services[serviceIndex]);
            }
          });
          
          extrasSelected.forEach(extraId => {
            let extraIndex = this.services.findIndex((extra) => extra.id === extraId);
            if (extraIndex != -1){
              this.extrasList.push(this.extras[extraIndex]);
            }
          });
        }, 500);
      }, 500);
    }else{
    }
    this.isDialogVisible = true;

  }

  resetForm(){
    this.housings = [];
    this.servicesList = [];
    this.extrasList = [];
    this.total = 0;
    this.form.reset();
    this.isDialogVisible = false;
    this.selectedEvent = null;
    this.selectedDate = null;
    this.form.patchValue({
      type:1
    });
  
    if (this.loggedUser.role_id == 4){
      this.loadHousings(this.loggedUser.id,true);
    }
  }

  selectedUser($event){
    let user_id = $event.value;
    this.housings = [];
    this.services = [];
    this.servicesList = [];
    this.extrasList = [];
    this.total = 0;
    this.loadHousings(user_id,true);
  }
  selectHousing($event){
    this.servicesList = [];
    this.extrasList = [];
    this.total = 0;
    let housing_id = $event.value;
    let index = this.housings.findIndex((housing) => housing.id === housing_id);
    if (index >= 0){
      this.services = [];
      this.loadServices(housing_id,true);
      this.loadExtras(housing_id,true);
    }
  }

  getEvents(){
    this.reservations = [];
    this.calendarApi = this.calendarComponent.getApi();
    let currentDate = this.calendarApi.view.currentStart;
    let month = moment(currentDate).month() + 1;
    let year = moment(currentDate).year();

    this.loadReservations(month,year);
  }

  
	public updateReservation(reservation,status) {
		if (this.loading) return;
		var message = '';
		if (status == 2){
			message = '¿Está seguro que desea procesar como "completada" esta reserva? No se puede deshacer';
		}
		if (status == 0){
			message = '¿Está seguro que desea procesar como "no completada" esta reserva? No se puede deshacer';
		}
		this.confirmationService.confirm({
			header:'Procesar reserva',
			message: message,
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				this.loading = true;
				this.apiService.addEntity("processReservation", {
					id:reservation.id,
					status:status
				}).subscribe({
					next: () => {
						this.loading = false;
						this.toast.show("Reserva procesada");
						this.getEvents();
					},
					error: () => {
						this.loading = false;
						this.toast.show(
							"Error",
							"Ocurrió un error, inténtelo de nuevo",
							"error"
						);
					},
				});
			},
		});
	}

  addService() {
    const serviceId = this.form.value.service;
    const service = this.services.find(s => s.id === serviceId);
    if (service) {
      this.servicesList.push(service);
      this.form.patchValue({ service: null });
      this.loadPrices();
    }
  }
  
  addExtra() {
    const extraId = this.form.value.extra;
    const extra = this.extras.find(e => e.id === extraId);
    if (extra) {
      this.extrasList.push(extra);
      this.form.patchValue({ extra: null });
      this.loadPrices();
    }
  }

  deleteService(i){
    this.servicesList.splice(i,1);
    this.loadPrices();
  }

  deleteExtra(i){
    this.extrasList.splice(i,1);
    this.loadPrices();
  }
}
